export default __webpack_public_path__ + "static/media/1679.cb63bdca.png";